import { Attribute, Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { HoldersContributionsDisDialogComponent } from '../holders-contributions-dis-dialog/holders-contributions-dis-dialog.component';
import { HoldersManagerSelectionDialogComponent } from '../holders-manager-selection-dialog/holders-manager-selection-dialog.component';
import { HoldersContributionsDisDeclineDialogComponent } from '../holders-contributions-dis-cancel-dialog/holders-contributions-dis-cancel-dialog.component';
import { HoldersContributionsDisUploadDialogComponent } from '../holders-contributions-dis-upload-dialog/holders-contributions-dis-upload-dialog.component';
import { HoldersContributionsDisPreviewDialogComponent } from '../holders-contributions-dis-preview-dialog/holders-contributions-dis-preview-dialog.component';
import { CombosService } from '../../../services/combos.service';
import { GeTableComponent } from '../../../share/components/ge-table.component';
import { FormatCurrencyPipe } from '../../../share/components/pipe/FormatCurrency.pipe';
import { ParseCurrencyPipe } from '../../../share/components/pipe/ParseCurrency.pipe';

import {
  AportacionDIPoseedorControllerService,
  AportacionDIPoseedorFilterDTO,
  PoseedorControllerService,
  PoseedorFilterDTO,
  SolicitudNimaGestoresDTO,
  SolicitudNimaPoseedorDTO,
  AportacionDIEstadoControllerService,
  AportacionDIEstadoDTO,
  SolicitudPoseedorPrevisionDTO,
  PlataformaOrigenControllerService, PlataformaOrigenDTO,
  PoseedorEstadoControllerService,
  GestoresResiduosEstadosControllerService,
  IdEntityFilterDTO,
  GestionResiduosFilterDTO,
  CodigoLerControllerService,
  CodigoLerFilterDTO,
  OperacionGestionControllerService,
  DiccionarioElementoDTO,
  DiccionarioControllerService
} from 'api-rest';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import moment from 'moment';
import swal from 'sweetalert2';


@Component({
  selector: 'app-holders-contributions-dis',
  templateUrl: './holders-contributions-dis.component.html',
  styleUrls: ['./holders-contributions-dis.component.scss'],
})
export class HoldersContributionsDisComponent implements OnInit {
  tipoAcceso: string | null = null;
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;
  totalKilos: number | undefined;

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalElements: number = 0;
  totalSearch: number = 0;
  nimaPoseedorArray: any[] = [];
  nimaGestorArray: any[] = [];
  gestoresArray: any[] = [];
  globalIdPoseedores: any[] = [];
  poseedorArray: any[] = [];
  estadoArray: any[] = [];
  plataformaOrigenArray: any[] = [];
  cargadoPorArray: any[] = [];
  origenArray: {value: string; label: string}[] = [
    {value: "POSEEDOR", label: "Poseedores finales"},
    {value: "SDDRCA", label: "SDDR Abierto" },]
   headArray: any = [
    {
      Head: 'ID Pos.',
      FieldName: 'poseedor',
      Attribute: 'id',
      tooltipHeader: 'ID POSEEDOR',
    },
    {
      Head: 'Poseedor',
      FieldName: 'poseedor',
      Attribute: 'razonSocial',
      tooltipHeader: 'RAZÓN SOCIAL DEL POSEEDOR',
    },
    {
      Head: 'Documento',
      FieldName: 'poseedor',
      Attribute: 'codigoDocumento',
      tooltipHeader: 'DOCUMENTO DEL POSEEDOR (NIF, NIE)',
    },
    {
      Head: 'NIMA Pos.',
      FieldName: 'poseedor',
      Attribute: 'nima',
      tooltipHeader: 'NIMA DEL POSEEDOR',
    },
    {
      Head: 'NIMA Ges.',
      FieldName: 'gestorResiduo',
      renderValue: (item: any) => item?.gestorResiduo ? item?.gestorResiduo.nima : item?.nimaGestor,
      tooltipHeader: 'NIMA DEL GESTOR',
    },
    {
      Head: 'Fecha de aport.',
      FieldName: 'fechaMAportacion',
      tooltipHeader: 'FECHA APORTACIÓN',
    },
    {
      Head: 'Fecha de acep.',
      FieldName: 'fechaMAceptacion',
      tooltipHeader: 'FECHA ACEPTACIÓN',
    },
    {
      Head: 'DI/FS',
      FieldName: 'documentoIdentificacion',
      tooltipHeader: 'DOC. IDENTIFICACIÓN/FULL SEGUIMENT'
    },
    {
      Head: 'Cód. LER y descrip.',
      FieldName: 'descripcionMCodLer',
      tooltipHeader: 'CÓDIGO LER Y DESCRIPCIÓN',
      Tooltip: true,
      Maxtext: 25,
    },
    {
      Head: 'Op. Ges.',
      FieldName: 'descripcionOperacionGes',
      tooltipHeader: 'OPERACIÓN DE GESTIÓN',
      Tooltip: true,
      Maxtext: 25,
    },
    {
      Head: 'Cant. KG',
      FieldName: 'cantidadGestionada',
      tooltipHeader: 'CANTIDAD NETA GESTIONADA (KG)',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.cantidadGestionada),
    },
    {
      Head: 'Est aport',
      FieldName: 'estado',
      Attribute: 'descripcionCorta',
      tooltipHeader: 'ESTADO APORTACIÓN',
    },
    {
      Head: 'Cargado por',
      FieldName: 'esCreadoPoseedor',
      tooltipHeader: 'CARGADO POR',
      renderValue: ((item: any) => {
         if(item.esCreadoPoseedor == null || item.esCreadoPoseedor == undefined){
          return '';
         }else if(item.esCreadoPoseedor){
          return 'Poseedor';
         }else{
            //if(item.origen === 'POSEEDOR'){
            //  return 'Gestor';
            //}else{
            //  return 'Acondicionador';
            //}
            return 'Gestor';
         }
      })
    },
    {
      Head: 'Origen',
      FieldName: 'origen',
      tooltipHeader: 'ORIGEN',
      renderValue: (item: any) => item?.origen === 'POSEEDOR' ? 'Poseedores Finales' : 'SDDR Abierto',
    },
    {
      Head: 'Est. pos.',
      FieldName: 'poseedor',
      Attribute: 'estado.descripcionCorta',
      tooltipHeader: 'ESTADO POSEEDOR',
    },
    {
      Head: 'Acc.',
      FieldName: 'actions',
      tooltipHeader: 'ACCIONES',
      check: this.canAccessCrearAutoFactura(),
      showCheckedAll: this.canAccessCrearAutoFactura(),
      tooltipCheckedAll: 'Seleccionar todos',
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle ',
          show: {
            params: 'canAccessView',
            accion: 'view',
          },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Eliminar',
          show: {
            params: 'canAccessDelete',
            accion: 'delete',
          },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'preview',
              name: 'Vista previa',
              show: { params: 'canAccessPreview', accion: 'preview' },
            },
            {
              nameButton: 'send',
              name: 'Enviar aportación ',
              show: {
                params: 'canAccessSend',
                accion: 'send',
              },
            },
            {
              nameButton: 'accept',
              name: 'Aceptar aportación',
              show: { params: 'canAccessAccept', accion: 'accept' },
            },
            {
              nameButton: 'cancel',
              name: 'Cancelar aportación',
              show: { params: 'canAccessCancel', accion: 'cancel' },
            },
            {
              nameButton: 'correccionEnvalora',
              name: ' Corrección envalora',
              show: { params: 'canAccessCorreccionEnvalora', accion: 'correccionEnvalora' },
            },
          ],
        },
      ],
      width: '15',
      permanent: true,
    },
  ];
  headPlataformaOrigen: any = {
      Head: 'Plat. origen',
      FieldName: 'plataformaOrigen',
      Attribute: 'descripcion',
      tooltipHeader: 'PLATAFORMA ORIGEN',
  }
  gridArray: any[] = [];

  searchForm: FormGroup;

  updateList: boolean = false;
  poseedorEndpoint: string =
    this.environment.urlBackPoseedores + `api/v1/poseedores/poseedor`;
  // actualmente para el gest-env se quieren mostrar todos los poseedores, no solo los que están en estado 4 (aceptados)
  //defaultPoseedoresParameters = { 'estado.id': 4 };

  rolesGestor: any[] = [];
  rolesPoseedor: any[] = [];

  mostrarPlataformaOrigen: boolean = false;
  estadoPoseedorArray: any[] = [];
  estadoGestorArray: any[] = [];
  codigoLerArray: any[] = [];
  operacionGestionArray: any[] = [];

  listaGestores = this.environment.urlBackCore + 'api/v1/poseedores/gestores-residuos';
  defaultGestoresParameters = { 'gestorResiduos': true, 'gestoresResiduosEstado.id': [1, 2, 3] };

  @ViewChild(GeTableComponent) geTable?: GeTableComponent;

  orden: DiccionarioElementoDTO[] = [];
  mostrarFiltros: boolean = true;
  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private downloadService: DownloadService,
    private snackBarSrv: SnackbarService,
    private AportacionDIPoseedorControllerService: AportacionDIPoseedorControllerService,
    private aportacionesDiService: AportacionDIPoseedorControllerService,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService | any,
    private poseedorControllerService: PoseedorControllerService,
    private AportacionDIEstadoControllerService: AportacionDIEstadoControllerService,
    private plataformaOrigenControllerService: PlataformaOrigenControllerService,
    public comboService: CombosService,
    private formatCurrencyPipe: FormatCurrencyPipe,
    private parseCurrencyPipe : ParseCurrencyPipe,
    private poseedorEstadoControllerService: PoseedorEstadoControllerService,
    private gestorEstadoControllerService: GestoresResiduosEstadosControllerService,
    private codigoLerControllerService: CodigoLerControllerService,
    private operacionGestionControllerService: OperacionGestionControllerService,
    private diccionarioControllerService: DiccionarioControllerService
  ) {
    const fechadesde = `01/01/${moment().format('YYYY')}`;
    const [dia, mes, año] = fechadesde.split('/').map(Number);
    const fechaInicialDesde = new Date(año, mes - 1, dia);

    const fechaActual = new Date();
    const roleEntities = (this.authService.user as any).roleEntities;
    this.rolesGestor = roleEntities?.filter(
      (roleEntity: any) => roleEntity.role == 'PO-GESTOR'
    );
    this.rolesPoseedor = roleEntities?.filter(
      (roleEntity: any) => roleEntity.role == 'PO-POSEEDOR'
    );

    this.searchForm = this.formBuilder.group({
      poseedor: [{ value: null, disabled: false }],
      idposeedor: [{ value: null, disabled: false }, [Validators.pattern('^[0-9;]+$')]],
      gestor: [{ value: null, disabled: false }],
      codigo_documento: [{ value: null, disabled: false }],
      codigo_documento_gestor: [{ value: null, disabled: false }],
      razon_social: [{ value: null, disabled: false }],

      nima_poseedor: [{ value: null, disabled: false }],
      nima_gestor: [{ value: null, disabled: false }],
      fecha_desde: [
        { value: fechaInicialDesde, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      fecha_hasta: [
        { value: fechaActual, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      fecha_aport_desde: [
        { value: null, disabled: false },
      ],
      fecha_aport_hasta: [
        { value: null, disabled: false },
      ],
      doc_identificacion: [{ value: null, disabled: false }, [Validators.minLength(6)]],
      estado: [{ value: null, disabled: false }],
      origen: [{ value : null, disabled: false}],
      fechaAceptacion: [{ value: null, disabled: false }],
      plataformaOrigen: [{ value: null, disabled: false }],
      cargadoPor: [{ value: null, disabled: false }],
      cantidadDesde : [{ value: null, disabled: false }],
      cantidadHasta : [{ value: null, disabled: false }],
      estadoPoseedor: [{ value: null, disabled: false }],
      estadoGestor: [{ value: null, disabled: false }],
      codigoLer: [{ value: null, disabled: false }],
      operacionGestion: [{ value: null, disabled: false }],
                  orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],

    });

  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.tipoAcceso = params['tipo'] || null;

      // Resetear el estado del buscador al cambiar de vista
      this.flagSearch = false;
      this.gridArray = [];
      this.recordsTotal = 0;
      this.pageNumber = 0;

      if (this.tipoAcceso === 'gestor') {
        this.buscarNimaGestor();
        this.aportacionesDiService.obtenerGestores().subscribe((res) => this.gestoresArray = res);
      } else if (this.tipoAcceso === 'poseedor') {
        this.buscarNimaPoseedor();
      } else {
        // PO-ENV-GEST u otros: mantener comportamiento original
        if (this.rolesGestor?.length > 0) {
          this.buscarNimaGestor();
        }
        if (this.rolesPoseedor?.length > 0) {
          this.buscarNimaPoseedor();
        }
      }

      const fechadesde = `01/01/${moment().format('YYYY')}`;
      const [dia, mes, año] = fechadesde.split('/').map(Number);
      const fechaInicialDesde = new Date(año, mes - 1, dia);

      this.searchForm.patchValue({
        fecha_desde: fechaInicialDesde,
        fecha_hasta: new Date(),
      });
      this.comboEstados();
      this.comboEstadosPoseedor();
      this.comboEstadosGestor();
      this.comboCodigoLer();
      this.comboOperacionGestion();
      this.getPoseedores();
      this.cargadoPorArray = this.comboService.getCargadoPor();
      this.validarYCargarPlataformaOrigen();
      this.comboOrden();
    });
  }

  checked(event: any) {
    if (event.estado.id != 3) {
      this.snackBarSrv.showSnackBar(
        'Solo se permitirá prefacturar DIs en estado Aceptada',
        'error'
      );
      event.checked = null;
    }
  }

  selectAll(list: any[]) {
    const isChecking = this.geTable?.selectAllItems;
    if (!isChecking) return;

    const hasInvalidItems =
      list.length === 0 ||
      list.some((item) => (item.estado ? item.estado.id !== 3 : true));
    if (hasInvalidItems) {
      this.snackBarSrv.showSnackBar(
        'Solo se pueden seleccionar registros en estado Aceptada',
        'error'
      );
      list.forEach((item) => (item.checked = false));
      if (this.geTable) {
        setTimeout(() => {
          this.geTable!.selectAllItems = false;
        });
      }
    }
  }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.searchData();
    }
  }

  private getBackendFilter() {
    let formatDateDesde = moment(
      new Date(this.searchForm.get('fecha_desde')?.value)
    ).format('YYYY-MM-DD');

    let formatDateHasta = moment(
      new Date(this.searchForm.get('fecha_hasta')?.value)
    ).format('YYYY-MM-DD');

    //Fecha aportacion
    let fechaAportacion : string[] | undefined;
    if(this.searchForm.get('fecha_aport_desde')?.value || this.searchForm.get('fecha_aport_hasta')?.value){
      fechaAportacion = [];
      if(this.searchForm.get('fecha_aport_desde')?.value){
        let formatDateAportDesde = moment(
          new Date(this.searchForm.get('fecha_aport_desde')?.value)
        ).format('YYYY-MM-DD');

        formatDateAportDesde = `gte(${formatDateAportDesde})`;
        fechaAportacion.push(formatDateAportDesde);
      }
      if(this.searchForm.get('fecha_aport_hasta')?.value){
        let formatDateAportHasta = moment(
          new Date(this.searchForm.get('fecha_aport_hasta')?.value)
        ).format('YYYY-MM-DD');

        formatDateAportHasta = `and(lte(${formatDateAportHasta}))`;
        fechaAportacion.push(formatDateAportHasta);
      }
    }
    const selectPoseedores = this.searchForm.get('poseedor')?.value;

    let poseedorFilter: PoseedorFilterDTO;
    if(selectPoseedores && selectPoseedores.length > 0){
      poseedorFilter = {
        id: selectPoseedores?.map((objeto: any) =>
          objeto.id !== undefined ? objeto.id : objeto
        ),
      }
    }else{
      poseedorFilter = {
        id: [this.searchForm.get('idposeedor')?.value],
        //razonSocial: [this.searchForm.get('razon_social')?.value],
        nima: [this.searchForm.get('nima_poseedor')?.value],
        codigoDocumento: [this.searchForm.get('codigo_documento')?.value],
      }
    }

    const selectGestores = this.searchForm.get('gestor')?.value;

    let gestorFilter: GestionResiduosFilterDTO;
    if(selectGestores && selectGestores.length > 0){
      gestorFilter = {
        id: selectGestores?.map((objeto: any) =>
          objeto.id !== undefined ? objeto.id : objeto
        ),
      }
    }else{
      gestorFilter = {
        codigoDocumento: this.searchForm.get('codigo_documento_gestor')?.value,
      }
    }

    const selectEstadoP = this.searchForm.get('estadoPoseedor')?.value;
    let selectEstadosIdP: any[] = [];
    if (selectEstadoP !== undefined && selectEstadoP !== null) {
      selectEstadosIdP = selectEstadoP.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    poseedorFilter.estado = {
      id: (this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS')) && this.searchForm.get('estadoPoseedor')?.value ? selectEstadosIdP : undefined,
    }

    const selectEstadoG = this.searchForm.get('estadoGestor')?.value;
    let selectEstadosIdG: any[] = [];
    if (selectEstadoG !== undefined && selectEstadoG !== null) {
      selectEstadosIdG = selectEstadoG.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    gestorFilter.gestoresResiduosEstado = {
      id: (this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS')) && this.searchForm.get('estadoGestor')?.value ? selectEstadosIdG : undefined,
    }

    let origenFilter = this.searchForm.get('origen')?.value;
    let selectOrigenId: any[] = [];
    if (origenFilter !== undefined && origenFilter !== null) {
      selectOrigenId = origenFilter.map((objeto: any) =>
        objeto !== undefined ? objeto : objeto
      );
    }
    let esCreadoPoseedorFilter;
    if(this.searchForm.get('cargadoPor')?.value){
      if(this.searchForm.get('cargadoPor')?.value == 'Poseedor'){
        esCreadoPoseedorFilter = true;
      }else{
        esCreadoPoseedorFilter = false;
        if(this.searchForm.get('cargadoPor')?.value == 'Gestor'){
          origenFilter = AportacionDIPoseedorFilterDTO.OrigenEnum.Poseedor;
        }else{
          origenFilter = AportacionDIPoseedorFilterDTO.OrigenEnum.Sddrca;
        }
      }
    }
    let cantidadDesde = this.parseCurrencyPipe.transform(this.searchForm.get('cantidadDesde')?.value);

    let cantidadHasta = this.parseCurrencyPipe.transform(this.searchForm.get('cantidadHasta')?.value);
    const selectPlataformaOrigen = this.searchForm.get('plataformaOrigen')?.value;
    let selectPlataformaOrigenId: IdEntityFilterDTO = { id: [] };
    if (selectPlataformaOrigen !== undefined && selectPlataformaOrigen !== null) {
      if (Array.isArray(selectPlataformaOrigen) && selectPlataformaOrigen.length > 0) {
        selectPlataformaOrigenId.id = selectPlataformaOrigen.map((objeto: any) =>
          objeto.id !== undefined ? objeto.id : objeto
        );
      } else {
        selectPlataformaOrigenId.id = [
          (selectPlataformaOrigen as any).id !== undefined
            ? (selectPlataformaOrigen as any).id
            : (selectPlataformaOrigen as any),
        ];
      }
    }
    const selectEstado = this.searchForm.get('estado')?.value;
    let selectEstadosId: any[] = [];
    if (selectEstado !== undefined && selectEstado !== null) {
      selectEstadosId = selectEstado.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }

    const selectCodigoLer = this.searchForm.get('codigoLer')?.value;
    let selectCodigoLerId: any[] = [];
    if (selectCodigoLer !== undefined && selectCodigoLer !== null) {
      selectCodigoLerId = selectCodigoLer.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }

    const selectOperacionGestion = this.searchForm.get('operacionGestion')?.value;
    let selectOperacionGestionId: any[] = [];
    if (selectOperacionGestion !== undefined && selectOperacionGestion !== null) {
      selectOperacionGestionId = selectOperacionGestion.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }

    let tipoAportacione = '';
    if (this.tipoAcceso === 'gestor'){
      tipoAportacione = 'Gestores';
    } else if (this.tipoAcceso === 'poseedor'){
      tipoAportacione = 'Poseedores';
    }

    let backendFilter: any = {
      poseedor: poseedorFilter,
      gestorResiduo: gestorFilter,
      nimaGestor: selectGestores && selectGestores.length > 0 ? undefined : this.searchForm.get('nima_gestor')?.value,
      fechaAceptacion: [formatDateDesde, formatDateHasta],
      fechaAportacion: fechaAportacion,
      estado: { id: selectEstadosId },
      plataformaOrigen:selectPlataformaOrigenId,
      origen: origenFilter,
      esCreadoPoseedor: esCreadoPoseedorFilter,
      cantidadDesde: cantidadDesde,
      cantidadHasta: cantidadHasta,
      menuAportacionModuloPoseedores: tipoAportacione,
      codigoLer: { id: selectCodigoLerId },
      operacionGestion: { id: selectOperacionGestionId },
      // menuAportacionModuloPoseedores: tipoAportacione
    };
    if(this.searchForm.get('doc_identificacion')?.value){
      backendFilter.documentoIdentificacion = this.searchForm.get('doc_identificacion')?.value ? this.searchForm.get('doc_identificacion')?.value.trim() : undefined;
    }
    if(this.searchForm.get('razon_social')?.value){
      backendFilter.razonSocialPoseedor = this.searchForm.get('razon_social')?.value;
    }
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    return { backendFilter, page, size: this.pageSize, orden, tipoOrden };
  }

  exportarExcel() {

    if (this.esGestorEnvalora()) {
      this.descargaAsincrona();
    } else {
      const formatDateDesde = moment(new Date(this.searchForm.get('fecha_desde')?.value));
      const formatDateHasta = moment(new Date(this.searchForm.get('fecha_hasta')?.value));
      const diffDays = formatDateHasta.diff(formatDateDesde, 'days');

      if (diffDays > 366 && !this.esGestorEnvalora()) {
        this.snackBarSrv.showSnackBar(
          'El periodo de exportación no puede ser superior a un año',
          'error'
        );
        return;
      }

      this.descargasincrona();
    }

  }

  getPoseedorDescription(obj: any) {
    return obj.razonSocial + ' - ' + obj.nima + ' - ' +  obj.denominacionCentro;
  }

  getGestorDescription(obj: any) {
    return obj?.razonSocial + ' - ' + obj?.nima + ' - ' + obj?.centro;
  }

  getGestorObjectQuery(searchterm: string) {
    return {
      razonSocialOrNima: searchterm,
      'estado.id': 4,
    };
  }

  getPoseedorObjectQuery(searchterm: string) {
    return {
      razonSocialOrNima: `${searchterm}`,
      /* SE QUIEREN TODOS LOS ESTADOS PARA EL GESTOR ENV 
      'estado.id': 4,*/
    };
  }

  clearSearcher() {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) => {
          if (typeof v === 'object' && v !== null && typeof filtro.value === 'object' && filtro.value !== null) {
            return v.id !== filtro.value.id;
          }
          return v !== filtro.value;
        });
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }
    //this.searchData(true);
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const poseedores = this.searchForm.get('poseedor')?.value as any[];
    if (poseedores?.length) {
      poseedores.forEach((p: any) => {
        if (typeof p === 'object' && p !== null) {
          filtros.push({ label: this.getPoseedorDescription(p), campo: 'poseedor', value: p });
        } else {
          const found = this.poseedorArray.find((x) => x.id === p);
          const label = found ? this.getPoseedorDescription(found) : `Pos: ${p}`;
          filtros.push({ label, campo: 'poseedor', value: p });
        }
      });
    }

    const gestores = this.searchForm.get('gestor')?.value as any[];
    if (gestores?.length) {
      gestores.forEach((gestor: any) => {
        const label = gestor?.razonSocial ? this.getGestorDescription(gestor) : String(gestor);
        filtros.push({ label, campo: 'gestor', value: gestor });
      });
    }

    const idPoseedor = this.searchForm.get('idposeedor')?.value;
    if (idPoseedor) filtros.push({ label: ` ${idPoseedor}`, campo: 'idposeedor' });

    const doc = this.searchForm.get('codigo_documento')?.value;
    if (doc?.trim()) filtros.push({ label: doc.trim(), campo: 'codigo_documento' });

    const docGestor = this.searchForm.get('codigo_documento_gestor')?.value;
    if (docGestor?.trim()) filtros.push({ label: docGestor.trim(), campo: 'codigo_documento_gestor' });

    const nimaGestor = this.searchForm.get('nima_gestor')?.value;
    if (nimaGestor) filtros.push({ label: ` ${nimaGestor}`, campo: 'nima_gestor' });

    const fDesde = this.searchForm.get('fecha_desde')?.value;
    if (fDesde) filtros.push({ label: ` ${moment(fDesde).format('DD/MM/YYYY')}`, campo: 'fecha_desde' });

    const fHasta = this.searchForm.get('fecha_hasta')?.value;
    if (fHasta) filtros.push({ label: `${moment(fHasta).format('DD/MM/YYYY')}`, campo: 'fecha_hasta' });

    const fAportDesde = this.searchForm.get('fecha_aport_desde')?.value;
    if (fAportDesde) filtros.push({ label: ` ${moment(fAportDesde).format('DD/MM/YYYY')}`, campo: 'fecha_aport_desde' });

    const fAportHasta = this.searchForm.get('fecha_aport_hasta')?.value;
    if (fAportHasta) filtros.push({ label: ` ${moment(fAportHasta).format('DD/MM/YYYY')}`, campo: 'fecha_aport_hasta' });

    const docId = this.searchForm.get('doc_identificacion')?.value;
    if (docId?.trim()) filtros.push({ label: docId.trim(), campo: 'doc_identificacion' });

    const estados = this.searchForm.get('estado')?.value as any[];
    if (estados?.length) {
      estados.forEach((est: any) => {
        filtros.push({ label: est.descripcionCorta ?? String(est), campo: 'estado', value: est });
      });
    }

    const estadosPoseedor = this.searchForm.get('estadoPoseedor')?.value as any[];
    if (estadosPoseedor?.length) {
      estadosPoseedor.forEach((est: any) => {
        filtros.push({ label: est.descripcionCorta ?? String(est), campo: 'estadoPoseedor', value: est });
      });
    }

    const estadosGestor = this.searchForm.get('estadoGestor')?.value as any[];
    if (estadosGestor?.length) {
      estadosGestor.forEach((est: any) => {
        filtros.push({ label: est.descripcionCorta ?? String(est), campo: 'estadoGestor', value: est });
      });
    }

    const codigosLer = this.searchForm.get('codigoLer')?.value as any[];
    if (codigosLer?.length) {
      codigosLer.forEach((codigo: any) => {
        const label = codigo?.tipoCodigo
          ? `${codigo.tipoCodigo} ${codigo.descripcion ?? ''}`
          : String(codigo);
        filtros.push({ label, campo: 'codigoLer', value: codigo });
      });
    }

    const operaciones = this.searchForm.get('operacionGestion')?.value as any[];
    if (operaciones?.length) {
      operaciones.forEach((operacion: any) => {
        const label = operacion?.codigo
          ? `${operacion.codigo} ${operacion.descripcion ?? ''}`
          : String(operacion);
        filtros.push({ label, campo: 'operacionGestion', value: operacion });
      });
    }

    const origenes = this.searchForm.get('origen')?.value as any[];
    if (origenes?.length) {
      origenes.forEach((o: string) => {
        const found = this.origenArray.find((x) => x.value === o);
        filtros.push({ label: found?.label ?? o, campo: 'origen', value: o });
      });
    }

    const plataformas = this.searchForm.get('plataformaOrigen')?.value as any[];
    if (plataformas?.length) {
      plataformas.forEach((p: any) => {
        filtros.push({ label: p.descripcion ?? String(p), campo: 'plataformaOrigen', value: p });
      });
    }

    const cargadoPor = this.searchForm.get('cargadoPor')?.value;
    if (cargadoPor) {
      const found = this.cargadoPorArray.find((x: any) => x.id === cargadoPor);
      filtros.push({ label: ` ${found?.name ?? cargadoPor}`, campo: 'cargadoPor' });
    }

    const cantDesde = this.searchForm.get('cantidadDesde')?.value;
    if (cantDesde !== null && cantDesde !== undefined && cantDesde !== '') {
      filtros.push({ label: ` ${cantDesde}`, campo: 'cantidadDesde' });
    }
    const cantHasta = this.searchForm.get('cantidadHasta')?.value;
    if (cantHasta !== null && cantHasta !== undefined && cantHasta !== '') {
      filtros.push({ label: ` ${cantHasta}`, campo: 'cantidadHasta' });
    }
const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }
    return filtros;
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.searchForm.controls[controlName].hasError(errorName) &&
      this.searchForm.controls[controlName].touched
    );
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'poseedor': {
        return this.searchForm.get('poseedor') as FormControl;
      }
      case 'gestor': {
        return this.searchForm.get('gestor') as FormControl;
      }
      default: {
        return this.searchForm.get('') as FormControl;
      }
    }
  }

  searchData(initPage:boolean = false) {
    if(initPage){
      this.pageNumber = 0;
      if (this.geTable) {
        this.geTable.selectAllItems = false;
      }
    }
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
      return;
    }
    const { backendFilter, page, size, orden, tipoOrden } = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.AportacionDIPoseedorControllerService
      ?.findAll13(backendFilter ?? {}, {
        page: page,
        size: size,
        sort: ['id,desc'],
      },
        orden,
        tipoOrden                                                                                                                                                                                                                                                                                                                                                                                     )
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.spinnerSrv.loadingHide();
            this.flagSearch = data.datos?.length != 0 ? true : false;
            this.gridArray = this.canAccessAll(data.datos);
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
        },
      });
    this.aportacionesDiService.getTotalKilos(backendFilter).subscribe({
      next: (total) => { this.totalKilos = total; },
      error: () => { this.totalKilos = undefined; },
    });
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  action(element: any) {
    if (element.nameButton == 'view') {
      this.openModalContributions(true,false, element);
    } else if (element.nameButton == 'delete') {
      this.confirmacionEliminar(element);
    } else if (element.nameButton == 'send') {
      this.spinnerSrv.loadingShow();
      this.AportacionDIPoseedorControllerService
        .enviarAportacion(element.id)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.searchData();
            this.snackBarSrv.showSnackBar(
              'Se ha enviado la aportación correctamente',
              'success'
            );
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
          },
        });
    } else if (element.nameButton == 'accept') {
      this.spinnerSrv.loadingShow();
      this.AportacionDIPoseedorControllerService
        .aceptarAportacion(element.id)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.searchData();
            this.snackBarSrv.showSnackBar(
              'Se ha aceptado la aportación correctamente',
              'success'
            );
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
          },
        });
    } else if (element.nameButton == 'cancel') {
      this.openModalMotivoCancel(element);
    }else if (element.nameButton == 'preview'){
      this.vistaPreviaAportacion(element);
    }else if (element.nameButton == 'correccionEnvalora'){
       this.spinnerSrv.loadingShow();
   
      this.AportacionDIPoseedorControllerService
        .correcionEnvalora(element.id)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.searchData();
            this.snackBarSrv.showSnackBar(
              'Se ha actualizado la aportación a corrección Envalora correctamente',
              'success'
            );
          },
          error: (err) => {
            this.spinnerSrv.loadingHide();
            console.log(err);
          },
        });
    }
  }

  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar la aportación DI/FS?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarDis(element);
      }
    });
  }

  eliminarDis(element?: any) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.AportacionDIPoseedorControllerService
        .deleteById6(element.id)
        .subscribe({
          next: (value: any) => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              `La aportación DI/FS se ha eliminado correctamente`,
              'success'
            );
            this.gridArray = this.gridArray.filter(
              (objeto) => objeto.id !== element.id
            );
            this.flagSearch = this.gridArray.length != 0 ? true : false;
          },
          error: (err: { message: any }) => {
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

  getPoseedores() {
    if (this.tipoAcceso === 'gestor') {
      const gestorIds = this.rolesGestor.flatMap((gestorRol: any) => {
          if(gestorRol.entity == null || gestorRol.entity == undefined){
            return [];
          }else if (Array.isArray(gestorRol.entity)) {
            return gestorRol.entity;
          } else {
            return [gestorRol.entity];
          }
        });
      const filtroNimaPoseedor: SolicitudPoseedorPrevisionDTO = {
        fechaAceptacion: moment(new Date()).format('YYYY-MM-DD'),
        gestor: {
          id: gestorIds,
        },
      };

      this.spinnerSrv.loadingShow();
      this.aportacionesDiService
        .getPoseedoresEnPrevision(filtroNimaPoseedor)
        .subscribe({
          next: (response: any) => {
            this.poseedorArray = response;
            this.globalIdPoseedores = this.poseedorArray?.map(
              (data: any) => data.id
            );
            this.spinnerSrv.loadingHide();
          },
          error: (err) => {
            console.log(err);
            this.spinnerSrv.loadingHide();
          },
        });
    } else if (this.tipoAcceso === 'poseedor') {
      const poseedorIds = this.authService.user?.roleEntities
        .filter((poseedorRol: any) => poseedorRol.type === 'POSEEDOR')
        .flatMap((poseedorRol: any) => {
          if(poseedorRol.entity == null || poseedorRol.entity == undefined){
            return [];
          }else if (Array.isArray(poseedorRol.entity)) {
            return poseedorRol.entity;
          } else {
            return [poseedorRol.entity];
          }
        });
      const filter: PoseedorFilterDTO = {
        id: poseedorIds,
        estado: {
          id: ['4'],
        },
      };

      this.spinnerSrv.loadingShow();
      this.poseedorControllerService
        .findAll5(filter, { page: 0, size: 100 })
        .subscribe({
          next: (response: any) => {
            this.poseedorArray = response?.datos;
            this.globalIdPoseedores = this.poseedorArray?.map(
              (data: any) => data.id
            );
            this.spinnerSrv.loadingHide();
          },
          error: (err) => {
            console.log(err);
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

  comboEstados() {
    this.AportacionDIEstadoControllerService.findAll14().subscribe({
      next: (data: Array<AportacionDIEstadoDTO>) => {
        this.estadoArray = data?.filter(item => item.id !== 1 && item.id !== 6) || [];
      },
      error: () => {},
    });
  }
  comboEstadosPoseedor() {
    this.poseedorEstadoControllerService.findAll6().subscribe({
      next: (data: Array<AportacionDIEstadoDTO>) => {
        this.estadoPoseedorArray = data || [];
      },
      error: () => {},
    });
  }
  comboEstadosGestor() {
    this.gestorEstadoControllerService.findAll9().subscribe({
      next: (data: Array<AportacionDIEstadoDTO>) => {
        this.estadoGestorArray = data || [];
      },
      error: () => {},
    });
  }
  comboCodigoLer() {
    // Módulo Poseedores: solo códigos LER habilitados para poseedores
    const filter: CodigoLerFilterDTO = { poseedores: true };
    this.codigoLerControllerService.findAll4(filter, { page: 0, size: 100 }).subscribe({
      next: (data: any) => {
        this.codigoLerArray = data.datos || [];
      },
      error: () => {},
    });
  }
  comboOperacionGestion() {
    const filter: any = {}
    this.operacionGestionControllerService.findAll7(filter, { page: 0, size: 100 }).subscribe({
      next: (data: any) => {
        this.operacionGestionArray = data.datos || [];
        },
      error: () => {},
    });
  }
  comboOrden() {
    this.diccionarioControllerService.listarElementos(['ORDEN_POSEEDORES_APORTACIONES_DI_FS_BUSQUEDA']).subscribe({
      next: (responses: any) => {
        this.orden = responses['ORDEN_POSEEDORES_APORTACIONES_DI_FS_BUSQUEDA'] || [];
      },
      error: () => {},
    });
  }
  validarYCargarPlataformaOrigen(){
    if(this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS')){
      this.accesoAPlataformaOrigen();
    }else{
      //Llamar a endpoint para saber si el usuario tiene datos en plataformas de origen distintas a Envanet.
      //En caso afirmativo, mostrar el filtro y la columna Plataforma Origen, sino, ocultarlos.

      this.AportacionDIPoseedorControllerService.comprobarPlataformaOrigen().subscribe({
        next: (response) => {
          if(response){
            this.accesoAPlataformaOrigen();
          }
        },
        error: (err) => {

        }
      })
    }
  }

  accesoAPlataformaOrigen(){
    this.mostrarPlataformaOrigen = true;
    //Insertar this.headPlataformaOrigen antes del elemento con Attribute 'estado.descripcionCorta'
    const actionsIndex = this.headArray.findIndex((item: any) => item.Attribute === 'estado.descripcionCorta');
    if (actionsIndex !== -1) {
      this.headArray.splice(actionsIndex, 0, this.headPlataformaOrigen);
    } else {
      this.headArray.push(this.headPlataformaOrigen);
    }
    this.comboPlataformaOrigen();
  }

  comboPlataformaOrigen() {
    this.plataformaOrigenControllerService.findAll6().subscribe({
      next: (data: Array<PlataformaOrigenDTO>) => {
        this.plataformaOrigenArray = data!;
      },
      error: () => {},
    });
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.searchForm.controls[controlName]?.touched ||
        this.searchForm.controls[controlName]?.dirty) &&
      this.searchForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  openHolderManagerSelection(isDetail: boolean, esMultipleDI?: boolean) {
    const dialogRef = this.dialog.open(HoldersManagerSelectionDialogComponent, {
      width: '950px',
      maxWidth: '98%',
      maxHeight: '95vh',
      disableClose: true,
      data:{
        titulo: isDetail ? 'Alta de aportación de DI/FS' : 'Cargar aportaciones DI/FS',
        isDetail: isDetail,
        tipoAcceso: this.tipoAcceso,
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        //Hace falta determinar si se ha hecho click sobre un gestor o un poseedor.
        // if (result?.gestorAndPoseedor &&
        //   this.poseedorArray.some(
        //     p => p.id === result.gestorAndPoseedor.id)) {
        //   result.poseedor = result?.gestorAndPoseedor
        // } else if(result?.gestorAndPoseedor &&
        //   this.gestoresArray.some(
        //     p => p.id === result.gestorAndPoseedor.id)) {
        //   result.gestorResiduo = result?.gestorAndPoseedor
        // }
        // this.openModalContributions(isDetail, result);
        this.openModalContributions(isDetail,esMultipleDI, result);
      }
    });
  }

  buscarNimaGestor() {

    let tipoAportacione = '';
    if (this.tipoAcceso === 'gestor') {
      tipoAportacione = 'Gestores';
    } else if (this.tipoAcceso === 'poseedor') {
      tipoAportacione = 'Poseedores';
    }

    const filtroNimaGestor: SolicitudNimaGestoresDTO = {
      fechaAceptacion: this.searchForm.get('fechaAceptacion')?.value,
      menuAportacionModuloPoseedores: tipoAportacione
    };

    this.aportacionesDiService
      .nimaGestores(filtroNimaGestor)
      .subscribe((res) => (this.nimaGestorArray = res));
  }

  buscarNimaPoseedor() {

    let tipoAportacione = '';
    if (this.tipoAcceso === 'gestor') {
      tipoAportacione = 'Gestores';
    } else if (this.tipoAcceso === 'poseedor') {
      tipoAportacione = 'Poseedores';
    }

    const filtroNimaPoseedor: SolicitudNimaPoseedorDTO = {
      fechaAceptacion: this.searchForm.get('fechaAceptacion')?.value,
      menuAportacionModuloPoseedores: tipoAportacione,
    };

    this.aportacionesDiService
      .nimaPoseedores(filtroNimaPoseedor)
      .subscribe((res) => (this.nimaPoseedorArray = res));
  }

  openModalContributions(isDetail:boolean, esMultipleDI?: boolean, element?: any, ) {
    if (!element) {
      if (this.tipoAcceso === 'gestor') {
        this.openModalGestores(isDetail, esMultipleDI);
      } else if (this.tipoAcceso === 'poseedor') {
        this.openModalPoseedores(isDetail, esMultipleDI);
      } else {
        //Si el usuario tiene roles de gestor y poseedor, primero comprobar los gestores y sino tiene, los poseedores
        if (this.rolesGestor?.length > 0 && this.rolesPoseedor?.length > 0){
          if(this.nimaGestorArray?.length > 0){
            this.openModalGestores(isDetail, esMultipleDI);
          }else{
            this.openModalPoseedores(isDetail, esMultipleDI);
          }
        }else if (this.rolesGestor?.length > 0) {

          this.openModalGestores(isDetail, esMultipleDI);

        } else if (this.rolesPoseedor?.length > 0) {

          this.openModalPoseedores(isDetail, esMultipleDI);

        }
      }
    } else {

      let tipoAportacione = '';
      if (this.tipoAcceso === 'gestor') {
        tipoAportacione = 'Gestores';
      } else if (this.tipoAcceso === 'poseedor') {
        tipoAportacione = 'Poseedores';
      }

      if(isDetail){
        const dialogRef = this.dialog.open(
          HoldersContributionsDisDialogComponent,
          {
            width: '1300px',
            maxWidth: '98%',
            maxHeight: '95vh',
            data: { ...element, tipoAcceso: tipoAportacione },
            disableClose: true,
          }
        );

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.searchData();
          }
        });
      }else{
        const dialogRef = this.dialog.open(
          HoldersContributionsDisUploadDialogComponent,
          {
            width: '950px',
            maxWidth: '98%',
            maxHeight: '95vh',
            data: {
              //Poseedor o gestor
              poseedorOrGestor: element,
              esMultipleDI: esMultipleDI

            },
            disableClose: true,
          }
        );

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.searchData();
          }
        });
      }

    }
  }

  openModalGestores(isDetail: boolean,esMultipleDI?: boolean){
    if (this.nimaGestorArray?.length === 0) {
      this.snackBarSrv.showSnackBar(
        'No puede crear una Aportación DI/FS porque no tiene ningún Gestor en estado Completado.',
        'error'
      );
    }
    if (this.nimaGestorArray?.length > 1) {
      this.openHolderManagerSelection(isDetail, esMultipleDI);
    } else {
      this.openModalContributions(isDetail,
        esMultipleDI,{
        gestorResiduo: {
          id: this.nimaGestorArray[0].id,
          nima: this.nimaGestorArray[0].nima,
          razonSocial: this.nimaGestorArray[0].razonSocial
        },
        estado: { id: 1, descripcion: 'Abierta' },
      });
    }
  }

  openModalPoseedores(isDetail: boolean, esMultipleDI?: boolean){
    if (this.nimaPoseedorArray?.length === 0) {
      this.snackBarSrv.showSnackBar(
        'No puede crear una Aportación DI/FS porque no tiene ningún Poseedor en estado Completado.',
        'error'
      );
    }
    if ((isDetail && this.nimaPoseedorArray?.length > 1) ||
        (!isDetail && this.nimaPoseedorArray?.filter((item:any) => item.cargaMasiva)?.length > 1)) {
      this.openHolderManagerSelection(isDetail, esMultipleDI);
    } else {
      let posModal;
      if(isDetail){
        posModal = this.nimaPoseedorArray[0];
      }else{
        posModal = this.nimaPoseedorArray.filter((item:any) => item.cargaMasiva)[0];
      }
      this.openModalContributions(isDetail,
        esMultipleDI,{
        poseedor: {
          id: posModal.id,
          nima: posModal.nima,
          razonSocial: posModal.razonSocial,
          residuosEnvase : posModal.residuosEnvase,
        },
        estado: { id: 1, descripcion: 'Abierta' },
      });
    }
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  esGestorEnvalora(){
    return this.canViewResource('SDDR-CA-ENV-GEST') || this.canViewResource('SDDR-CA-ENV-CONS') || this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS');
  }

  canAccessAll(list: any) {
    const resultView = this.authService.can('poseedores-di', 'view');
    const resultDelete = this.authService.can('poseedores-di', 'delete');

    const resultSend = this.authService.can('poseedores-di', 'update-send');
    const resultAccept = this.authService.can('poseedores-di', 'update-accept');
    const resultCancel = this.authService.can('poseedores-di', 'update-cancel');

    const listPermission = list?.map((objeto: any) => {
      const estado1 = objeto.estado && objeto.estado.id === 1;
      const estado2 = objeto.estado && objeto.estado.id === 2;
      const estado3 = objeto.estado && objeto.estado.id === 3;
      const estado5 = objeto.estado && objeto.estado.id === 5;
      const estado7 = objeto.estado && objeto.estado.id === 7;
      const estado8 = objeto.estado && objeto.estado.id === 8;
      const estado9 = objeto.estado && objeto.estado.id === 9;
      const estado10 = objeto.estado && objeto.estado.id === 10;
      objeto.fechaMAceptacion =
        objeto.fechaAceptacion != null
          ? moment(new Date(objeto.fechaAceptacion)).format('DD/MM/YYYY')
          : null;
      objeto.fechaMAportacion =
        objeto.fechaAportacion != null
          ? moment(new Date(objeto.fechaAportacion)).format('DD/MM/YYYY')
          : null;
      let descripcionMCodLer = objeto.codigoLer ?
        objeto.codigoLer?.tipoCodigo + ' ' + objeto.codigoLer?.descripcion
        : '';
      let descripcionOperacionGes = objeto.operacionGestion ?
        objeto.operacionGestion?.codigo + ' ' + objeto.operacionGestion?.descripcion
        : '';
        const hasDocument = objeto.documento ? true : false;

      return {
        ...objeto,
        canAccessView: resultView,
        canAccessDelete:
          resultDelete &&
          estado1 &&
          objeto.creadoPor == this.authService.getCurrentUserMail(),
        canAccessSend:
          resultSend &&
          estado1 &&
          objeto.creadoPor == this.authService.getCurrentUserMail(),
        canAccessAccept: resultAccept && (estado8 || estado5 || estado9) || (estado10 && this.puedeEditarAportacionEstadoCorrecionEnvalora()),
        canAccessCancel: resultCancel && (estado3 || estado7 || estado8 || estado9 || (estado10 && this.puedeEditarAportacionEstadoCorrecionEnvalora())),
        canAccessPreview: hasDocument,
        descripcionMCodLer: descripcionMCodLer,
        descripcionOperacionGes: descripcionOperacionGes,
        canAccessCorreccionEnvalora: (estado8 || estado3) && this.puedeEditarAportacionEstadoCorrecionEnvalora()
      };
    });

    return listPermission;
  }

  crearAutoFactura() {
    const list = this.gridArray.filter((x) => {
      return x.checked === true;
    });

    if (list.length == 0) {
      this.snackBarSrv.showSnackBar(
        `Debe seleccionar al menos una Aportación DI/FS para generar una prefactura`,
        'error'
      );
      return;
    }
    this.spinnerSrv.loadingShow();
    this.AportacionDIPoseedorControllerService
      .generarAutoFactura(list)
      .subscribe({
        next: () => {
          this.snackBarSrv.showSnackBar(
            `La prefactura se ha creado correctamente`,
            'success'
          );
          this.searchData();
          this.spinnerSrv.loadingHide();
        },
        error: (err) => {
          console.log(err);
          this.spinnerSrv.loadingHide();
        },
      });
  }

  canAccessNuevoDis(): boolean {
    return this.authService.can('poseedores-di', 'create');
  }

  canAccessCargaMasivaDis(): boolean {
    return this.canAccessNuevoDis() && (this.gestoresArray?.filter((item:any) => item.cargaMasiva).length > 0 || this.nimaPoseedorArray?.filter((item:any) => item.cargaMasiva).length > 0);
  }

  canAccessCrearAutoFactura(): boolean {
    return this.authService.can('poseedores-di', 'access-autofactura');
  }

  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  openModalMotivoCancel(item:any){
    const dialogRef = this.dialog.open(
      HoldersContributionsDisDeclineDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: item,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }


  vistaPreviaAportacion(element:any){
    const dialogRef = this.dialog.open(HoldersContributionsDisPreviewDialogComponent, {
      width: '98%',
      maxWidth: '98%',
      maxHeight: '95vh',
      data: element,
      disableClose: true,
    });
  }
//Estos metodos son de una tarea que no llego a PRO. Mas adelante se ha pedido modificaciones que afectaban a esta parte y se hizo con el codigo que habia en PRO.

  // openModalForPoseedoresAndGestores(isDetail: boolean){

  //       if (this.nimaPoseedorArray?.length === 0 && this.nimaGestorArray?.length === 0) {
  //     this.snackBarSrv.showSnackBar(
  //       'No puede crear una Aportación DI/FS porque no tiene ningún Poseedor o gestor en estado Completado.',
  //       'error'
  //     );
  //   }

  //   let poseedoresGestoresTotal = this.nimaGestorArray?.length + this.nimaPoseedorArray?.length

  //   if ((isDetail && poseedoresGestoresTotal > 1) ||
  //       (!isDetail && this.nimaPoseedorArray?.filter((item:any) => item.cargaMasiva)?.length > 1)
  //     || (this.nimaGestorArray?.length > 1)) {
  //     this.openHolderManagerSelection(isDetail);
  //   } else {

  //    this.comprobarArrayPoseedorGestor(isDetail)

  //   }
  // }

  // comprobarArrayPoseedorGestor(isDetail: boolean){
  //   if(this.nimaGestorArray?.length > 0){
  //      this.openModalContributions(isDetail,{
  //       gestorResiduo: {
  //         id: this.nimaGestorArray[0].id,
  //         nima: this.nimaGestorArray[0].nima,
  //         razonSocial: this.nimaGestorArray[0].razonSocial
  //       },
  //       estado: { id: 1, descripcion: 'Abierta' },
  //     });
  //   }else{

  //      let posModal;
      
  //     if(isDetail){
  //       posModal = this.nimaPoseedorArray[0];
  //     }else{
  //       posModal = this.nimaPoseedorArray.filter((item:any) => item.cargaMasiva)[0];
  //     }
  //     this.openModalContributions(isDetail,{
  //       poseedor: {
  //         id: posModal.id,
  //         nima: posModal.nima,
  //         razonSocial: posModal.razonSocial,
  //         residuosEnvase : posModal.residuosEnvase,
  //       },
  //       estado: { id: 1, descripcion: 'Abierta' },
  //     });

  //   }

  // }
     confirmarBottonExportar() {

        if(!this.esGestorResiduos()){
          this.exportarExcel();
          return;
        }
        swal.fire({
          text: 'Para descargar el detalle de las aportaciones registradas, debe confirmar que garantiza la confidencialidad y el correcto tratamiento de los datos de sus clientes poseedores finales.',
          icon: 'question',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: 'Confirmar',
          denyButtonText: 'Cancelar',
          allowOutsideClick: false,
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.exportarExcel();
          }
        });
      }

        esGestorResiduos(){
      return (this.tipoAcceso === 'gestor');
    }

      canViewRol(rol: string): boolean {
      return this.authService.hasCurrentUserRole(rol);
    }

    descargaAsincrona(){
          const { backendFilter, page, size } = this.getBackendFilter();
    this.AportacionDIPoseedorControllerService
      .exportCSV5(backendFilter, 'response')
      .subscribe((res: any) => {
        this.downloadService.exportModal();
      });
    }

         descargasincrona(){
          const { backendFilter, page, size } = this.getBackendFilter();
          this.spinnerSrv.loadingShow();
    this.AportacionDIPoseedorControllerService
      .exportCSV5(backendFilter, 'response')
      .subscribe((res: any) => {
        // this.downloadService.exportModal();
        const filename = this.downloadService.getFileName(
          res.headers,
          'ExportacionDi.xlsx'
        );
        this.downloadService.downloadBlob(res.body!, filename!);
        this.spinnerSrv.loadingHide();
      });
    }

  puedeEditarAportacionEstadoCorrecionEnvalora() {
    return this.canViewResource('PO-APORT-EDIC-TOTAL-ENV-GEST');
  }
}
